
import store from '@/store';
import { GET_IS_LOGGED_IN } from '@/store/constants';
import { ROUTER_LOGGER } from '@/services';
import { routes_names } from '../constants';

export function beforeEach(to, from, next){
  ROUTER_LOGGER.log(from.name,to.name)
	if(to.matched.some((record) => record.meta.requiresAuth) && !store.getters[GET_IS_LOGGED_IN]) next({ name: routes_names.login });
	else if(to.matched.some((record) => record.meta.notRequiresAuth) && store.getters[GET_IS_LOGGED_IN]) next({ name: routes_names.main });
	else next();
}